;(function($, undefined){

    'use strict';

    var rnn, log;

    function initBootstrapSelectors() {
        // default bootstrap icons don't use smart sprites, so we need to manually change
        // the icons on hover with jquery.

        $('.hat .navbar-inner .nav .only-non-authenticated-user a').hover(
            function () {
                $(this).find('.icon-user').toggleClass('icon-white');
            },
            function () {
                $(this).find('.icon-user').toggleClass('icon-white');
            }
        );
    }

    function initUiChanges() {
        initBootstrapSelectors();
    }

    rnn = window.rnn;

    log = rnn.logging.log;

    rnn.modules.register('uiChanges', {
        init: initUiChanges
    });

})(jQuery);
